import {
  SPI,
  FormIntegerFieldWidget,
  ViewType,
  ModelFieldType,
  FormFieldWidget
} from '@kunlun/dependencies';
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Search],
    ttype: ModelFieldType.Integer,
    name: 'planId',
    model: 'deli.aries.promotion.DeliAriesPromotionPlanDisableProxy',
    multi: false,
    widget: 'Integer',
    inline: false
  })
)
export class hiddenPlanidInput extends FormIntegerFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent('<div></div>');
    return this;
  }
}
